/**
 * What a page's own Refresh button does, collected for pull-to-refresh.
 *
 * On a phone the Refresh buttons are hidden: pulling the page down is the
 * gesture people expect there. Some pages fetch by hand rather than through
 * React Query, so a generic refetch cannot reach them. Every RefreshButton
 * registers its handler here while it is on screen, and the pull runs them,
 * so the pull always does at least what the hidden button would have.
 */
type Refresh = () => unknown;

const handlers = new Set<{ run: Refresh }>();

/** Register a handler; returns the unregister function. */
export function registerRefresh(run: Refresh): () => void {
  const entry = { run };
  handlers.add(entry);
  return () => {
    handlers.delete(entry);
  };
}

/** Run every registered handler and wait for all of them to settle. */
export async function runRegisteredRefreshes(): Promise<void> {
  await Promise.allSettled(
    Array.from(handlers, ({ run }) => Promise.resolve().then(run)),
  );
}
